// extracted by mini-css-extract-plugin
module.exports = {"receipt":"MLTranscription_receipt__R2EKb","animate":"MLTranscription_animate__0xkh6"};